import { Reveal } from "../lib/motion";

// Reusable section eyebrow + heading block.
export const SectionHead = ({ eyebrow, title, intro, light = false, align = "left" }) => (
  <div className={`max-w-3xl ${align === "center" ? "mx-auto text-center" : ""}`}>
    <Reveal>
      <p className="eyebrow mb-5">{eyebrow}</p>
    </Reveal>
    <Reveal delay={0.08}>
      <h2 className={`font-display font-semibold text-4xl md:text-5xl leading-[1.05] ${light ? "text-cream" : "text-ink"}`}>
        {title}
      </h2>
    </Reveal>
    {intro && (
      <Reveal delay={0.16}>
        <p className={`mt-6 text-lg leading-relaxed ${light ? "text-cream/70" : "text-slate"}`}>{intro}</p>
      </Reveal>
    )}
  </div>
);
